import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FaCog } from 'react-icons/fa';
import EMRelationGraph from '../Charts/EMRelationGraph.jsx'

class ClusterPanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      emds: [],
      papers: [],
      organisms: [],
      authors: [],
      linksEP: [],
      linksPO: [],
      linksPA: [],
    };
  }

  updateEMRelationGraph(maps) {
    let {
      listOrganism,
      listAuthorFull,
      listTeam,
      listPapers,
      dataListEMDs,
    } = this.props.base;
    let papers = [], organisms = [], authors = [],
      linksEP = [], linksPO = [], linksPA = [];
    let unknownOrgan = listOrganism.findIndex(o => o.id === '(null)');
    maps.forEach((m, midx) => {
      let paperId = dataListEMDs[m].d, teamList = dataListEMDs[m].u;
      let organismList = dataListEMDs[m].o;
      papers.push(paperId);
      organisms = organisms.concat(organismList);
      authors = authors.concat(teamList);
      linksEP.push([midx, paperId]);
      linksPO = linksPO.concat(organismList.map(o => [paperId, o])
        .filter(link => link[1] !== unknownOrgan));
      linksPA = linksPA.concat(teamList.map(u => [paperId, u]));
    });
    papers = papers.filter((p, index) => papers.indexOf(p) === index);
    organisms = organisms.filter((o, index) => organisms.indexOf(o) === index && o !== unknownOrgan);
    authors = authors.filter((a, index) => authors.indexOf(a) === index);
    linksEP.forEach(link => {
      link[1] = papers.indexOf(link[1]);
    })
    linksPO.forEach(link => {
      link[0] = papers.indexOf(link[0]);
      link[1] = organisms.indexOf(link[1]);
    })
    linksPA.forEach(link => {
      link[0] = papers.indexOf(link[0]);
      link[1] = authors.indexOf(link[1]);
    })
    papers = papers.map(p => ({
      name: listPapers[p] ? listPapers[p].title : '(unknown)',
      value: listPapers[p] ? listPapers[p].count : 0,
    }));
    organisms = organisms.map(o => ({
      name: listOrganism[o].name,
      value: listOrganism[o].count,
    }));
    authors = authors.map(a => ({
      name: listAuthorFull[listTeam[a].team[0]].name,
      value: listAuthorFull[listTeam[a].team[0]].count,
    }));
    let emds = maps.map(m => ({
      name: dataListEMDs[m].n,
      value: 1,
    }));

    this.setState ({
      emds,
      papers,
      organisms,
      authors,
      linksEP,
      linksPO,
      linksPA,
    });
  }

  render() {
    return (
      <EMRelationGraph
        emds={this.state.emds}
        papers={this.state.papers}
        organisms={this.state.organisms}
        authors={this.state.authors}
        linksEP={this.state.linksEP}
        linksPO={this.state.linksPO}
        linksPA={this.state.linksPA}
        height={this.props.height ? this.props.height : 700}
      />
    )
  }
}

export default ClusterPanel;
